import { Button, Card, Col, DatePicker, Form, Image, Input, InputNumber, Modal, Row, Switch, Table, Tabs, TreeSelect, Upload } from 'antd';
import { useEffect, useState } from 'react';
import { apiCall } from '../../../API/RestApi';
import { modalError } from '../../../Component/Modal/ModalLayout';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import Search from 'antd/es/input/Search';
import moment from 'moment';
import { currencyFormat } from '../../../Utils/formatCurrency';
import { urlProduct } from '../../../Utils/globalUrl';
import { useSelector } from 'react-redux';
import dayjs from "dayjs";
// const { RangePicker } = DatePicker;

function FormProduct() {
    const token = useSelector((state) => state.user.token);
    const navigate = useNavigate();
    const location = useLocation();

    //form
    const [form] = Form.useForm();
    const [formVariant] = Form.useForm();
    const [formBundle] = Form.useForm();

    const [file, setFile] = useState([]);
    const [category, setCategory] = useState();
    const [isActive, setIsActive] = useState(true);
    const [isActiveVariant, setIsActiveVariant] = useState(true);
    //modal variant
    const [isModalVariant, setIsModalVariant] = useState(false);
    //modal outlet product variant
    //data open modal
    const [dataModal, setdataModal] = useState(null);
    //data variant
    const [dataProductVariant, setDataProductVariant] = useState([]);
    const [productVariant, setProductVariant] = useState([]);


    //product
    const [product, setProduct] = useState([]);

    //warehouse
    const [bundle, setBundle] = useState([]);
    const [isModalBundle, setModalBundle] = useState(false);

    //outlet
    const [priceAfterVariantDiscount, setPriceAfterVariantDiscount] = useState(0);
    const [outletProductVariant, setOutletProductVariant] = useState([]);
    const [productCategoryPrice, setProductCategoryPrice] = useState([]);
    //selected


    const dateFormat = 'YYYY-MM-DD HH:mm:ss';

    const [imageUrl, setImageUrl] = useState();
    const [imageDel, setImageDel] = useState([]);
    const [variantProductDel, setVariantProductDel] = useState([]);
    const [uploadCount, setUploadCount] = useState(0);
    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
             sorter: false,
            key: "no",
            render: (id, record, index) => { ++index; return index; },
        },
        {
            title: 'Image',
            dataIndex: 'image',
            key: "image",
            render: (text, record) => {
                var img = record.image;
                if (img !== null && img !== 'null') {
                    if (img.split('/')[5] === 'null') {
                        return (<Image src="assets/photo_empty.png" width={50} height={50} />)
                    } else if (img.split('/')[5] === null) {
                        return (<Image src="assets/photo_empty.png" width={50} height={50} />)
                    } else {
                        return (<Image src={record.image} width={50} height={50}
                            fallback="data:image/png;base64,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"
                        />)
                    }
                } else {
                    return (<Image src="assets/photo_empty.png" width={50} height={50} />)
                }
            }
        },
        {
            title: 'Nama Varian',
            dataIndex: 'variant_name',
            key: "variant_name",
             sorter: false,
        },
        {
            title: 'Barcode',
            dataIndex: 'barcode_code',
            key: "barcode_code",
             sorter: false,
        },
        {
            title: 'Harga',
            dataIndex: 'price',
            key: "price",
             sorter: false,
            render: (text, record) => {
                return currencyFormat(Number(record.price));
            }
        },
        {
            title: 'Diskon (%)',
            dataIndex: 'discount_percent',
            key: "discount_percent",
             sorter: false,
            render: (text, record) => {
                if (record.discount_percent !== undefined && record.discount_percent !== null)
                    return record.discount_percent + '%';
                else
                    return '0%';
            }
        },
        {
            title: 'Harga Jual',
            dataIndex: 'price',
            key: "price",
             sorter: false,
            render: (text, record) => {
                var afterDis = record.price;
                if (record.discount_percent !== undefined && record.discount_percent !== null) {
                    afterDis = Number(record.price) - Number(record.discount_price);
                }
                return currencyFormat(afterDis);
            }
        },
        {
            title: 'Stok',
            dataIndex: 'stock',
            key: "stock",
             sorter: false,
            render: (text, record) => {
                if (record.stock === -1)
                    return "Unlimited";
                else
                    return record.stock + " " + record.satuan;
            }
        },
        {
            title: 'SKU',
            dataIndex: 'SKU',
            key: "SKU",
             sorter: false,
        },
        {
            title: 'Status',
            dataIndex: 'isActive',
            key: "isActive",
             sorter: false,
            render: (text, record) => {
                return (
                    <>
                        {
                            record.isActive === true ?
                                <b>Aktif</b>
                                :
                                <b>Tidak Aktif</b>
                        }
                    </>
                )
            }
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => {
                return (
                    <>
                        <Button type="primary" style={{ marginRight: 10 }} onClick={() => openForm(record, 'edit')} >
                            <EditOutlined />
                            <b style={{ marginLeft: 5 }}>Ubah</b>
                        </Button>
                        <Button type="primary" danger onClick={() => delForm(record)}>
                            <DeleteOutlined />
                            <b style={{ marginLeft: 5 }}>Hapus</b>
                        </Button>
                    </>
                );
            },
        },
    ];

    const column_category_price = [
        {
            title: 'No',
            dataIndex: 'no',
             sorter: false,
            key: "no",
            render: (id, record, index) => { ++index; return index; },
        },
        {
            title: 'Kategori',
            dataIndex: 'price_category',
            key: "price_category",
             sorter: false,
            render: (id, record, index) => {
                return record.price_category.name
            },
        },
        {
            title: 'Tipe',
            dataIndex: 'salesAdjustmentTypeName',
            key: "salesAdjustmentTypeName",
             sorter: false,
        },
        {
            title: 'Harga',
            dataIndex: 'price',
            key: "price",
             sorter: false,
        },
        {
            title: 'Diskon (%)',
            dataIndex: 'discount',
            key: "discount",
             sorter: false,
            render: (id, record, index) => {
                if (record.discount.discount_percent !== undefined && record.discount.discount_percent !== null)
                    return record.discount.discount_percent + '%';
                else
                    return '0%';
            },
        },
        {
            title: 'Diskon 2 (%)',
            dataIndex: 'discount',
            key: "discount",
             sorter: false,
            render: (id, record, index) => {
                if (record.discount.discount_percent_2 !== undefined && record.discount.discount_percent_2 !== null)
                    return record.discount.discount_percent_2 + '%';
                else
                    return '0%';
            },
        },
        {
            title: 'Harga Jual',
            dataIndex: 'price_after_discount',
            key: "price_after_discount",
             sorter: false,
            render: (id, record, index) => {
                var afterDis = record.price;
                if (record.discount_percent !== undefined && record.discount_percent !== null) {
                    afterDis = Number(record.price) - Number(record.discount_price);
                }
                return currencyFormat(afterDis);
            },
        },
    ];

    const column_bundle = [
        {
            title: 'No',
            dataIndex: 'no',
             sorter: false,
            key: "no",
            render: (id, record, index) => { ++index; return index; },
        },
        {
            title: 'Kode Produk',
            dataIndex: 'product_code',
            key: "product_code",
             sorter: false,
        },
        {
            title: 'Nama Produk',
            dataIndex: 'product_name',
            key: "product_name",
             sorter: false,
        },
        {
            title: 'Min Order',
            dataIndex: 'min_order',
            key: "min_order",
             sorter: false,
        },
    ];


    const openForm = (data, type) => {
        if (type === 'add') {
            setImageUrl(null);
            formVariant.resetFields();
            formVariant.setFieldValue('satuan', form.getFieldValue('satuan'))
            setIsModalVariant(true);
        } else {
            setdataModal(data)
            setIsActiveVariant(data.isActive);
            var img = null;
            if (data.image !== null) {
                img = data.image.split('/')[5];
            }
            if (img !== null && img !== 'null') {
                setImageUrl(data.image);
            } else {
                setImageUrl('assets/photo_empty.png')
            }
            formVariant.setFieldsValue({
                barcode: data.barcode_code,
                variant_name: data.variant_name,
                price: data.price,
                stock: data.stock,
                satuan: data.satuan,
                discount: data.discount_percent,
                SKU: data.SKU,
                isActive: data.isActive,
                discount_date_start: dayjs(data.discount_start),
                discount_date_end: dayjs(data.discount_end)
            })
            var dis = ((100 - Number(data.discount_percent)) / 100);
            var price = Number(data.price);
            var afterDis = dis * price;
            setPriceAfterVariantDiscount(afterDis);
            setIsModalVariant(true);
        }
    }

    const delForm = (v) => {
        Modal.confirm({
            title: 'NOTICE',
            content: 'Anda ingin menghapus data ini?',
            onOk: () => {
                var cek = imageDel.includes(v.imageNoUrl);
                if (cek === false) {
                    if (v.imageNoUrl !== null)
                        setImageDel([...imageDel, v.imageNoUrl]);
                }
                var out = outletProductVariant;
                var row = [];
                for (let i = 0; i < out.length; i++) {
                    var arr = out[i];
                    if (arr.id !== v.id) {
                        row.push(arr);
                    }
                }
                setOutletProductVariant(row);
                setVariantProductDel([...variantProductDel, v.id]);
                setProductVariant(productVariant => productVariant.filter(item => item.id !== v.id));
            },
        });
    }

    useEffect(() => {
        const state = location.state;
        if (state !== undefined && state !== null) {
            const item = state.item;
            getApi(item.product_id)

        }
        getApiNoPage('category');
        // getApiNoPage('outlet');
        getApiNoPage('product');
        // getApiNoPage('warehouse');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getApi = (id) => {
        const dataReq = {
            method: "GET",
            url: '/product/' + id,
            data: {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === 200) {
                var item = res.data.product;
                var variantProduct = [];
                const variant = res.data.variant;
                setIsActive(item.isActive);
                //PRODUK
                form.setFieldsValue({
                    product_code: item.product_code,
                    category: item.category_id,
                    product_name: item.product_name,
                    description: item.description,
                    satuan: item.product_satuans.length > 0 ? item.product_satuans[0].satuan : '',
                    rasio_satuan: item.product_satuans.length > 0 ? item.product_satuans[0].rasio_satuan : '',
                    isActive: item.isActive,
                    warehouse: item.warehouse_id
                })
                //VARIANT PRODUK
                if (variant !== undefined) {
                    for (let i = 0; i < variant.length; i++) {
                        var vp = variant[i];
                        //PRODUK
                        var arr_disc_variant = {};
                        var arr_variant = {
                            id: vp.variant_product_id,
                            barcode_code: vp.barcode_code,
                            variant_name: vp.variant_name,
                            price: vp.price,
                            min_order: vp.min_order,
                            stock: vp.stock,
                            satuan: item.product_satuans[0].satuan,
                            SKU: vp.SKU,
                            isActive: vp.isActive,
                            image: urlProduct + vp.image,
                            imageNoUrl: vp.image,
                            value: vp.variant_product_id,
                            title: vp.variant_name,
                            status: 'edit'
                        };
                        if (vp.discount !== undefined && vp.discount !== null) {
                            arr_disc_variant = {
                                discount_id: vp.discount_id,
                                discount_percent: vp.discount.discount_percent,
                                discount_percent_2: 0,
                                discount_price: vp.discount.discount_price,
                                price_after_discount: vp.price_after_discount,
                                discount_start: moment(vp.discount.discount_start).format(dateFormat),
                                discount_end: moment(vp.discount.discount_end).format(dateFormat),
                            }
                        }
                        variantProduct.push({ ...arr_variant, ...arr_disc_variant });
                    }
                }
                // setProductCategoryPrice(variant[0].product_category_prices);
                //set produk variant
                setProductVariant([...productVariant, ...variantProduct]);
                setDataProductVariant([...productVariant, ...variantProduct]);

                //bundle product
                // var row = [];
                // for (let i = 0; i < item.product_bundles.length; i++) {
                //     var product_bundles = item.product_bundles[i];
                //     row.push({
                //         product_id: product_bundles.product.product_id,
                //         product_code: product_bundles.product.product_code,
                //         product_name: product_bundles.product.product_name,
                //         min_order: product_bundles.product.min_order
                //     })
                // }
                // setBundle(row);
            }
        }).catch((e) => {
            console.log(e.message);
        })
    }

    const getApiNoPage = (url, id = null) => {
        var params;
        if (id !== null) {
            params = "&productId=" + id;
        }
        const dataReq = {
            method: "GET",
            url: '/' + url + '?nopage=true' + params,
            data: {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === 200) {
                var row = [];
                var item = res.data;
                if (url === 'category') {
                    for (let i = 0; i < item.length; i++) {
                        row.push({
                            value: item[i].category_id,
                            title: item[i].category_name,
                        })
                    }
                    setCategory(row);
                } else if (url === 'product') {
                    for (let i = 0; i < item.rows.length; i++) {
                        row.push({
                            value: JSON.stringify(item.rows[i]),
                            title: item.rows[i].product_name,
                        })
                    }
                    setProduct(row);
                }
            } else {
                console.log(res.message);
            }
        }).catch((e) => {
            console.log(e.message);
        })
    }

    const getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    };

    const uploadImage = (info) => {
        if (uploadCount > 0) {
            file.splice((file.length - 1), 1)
        }
        file.push(info.file);
        setFile(file);
        getBase64(info.file, (url) => {
            setImageUrl(url);
            setUploadCount(uploadCount + 1);
        });
    };

    const save = () => {
        var info = form.getFieldsValue();
        const state = location.state;
        var data = {
            "product": {
                "product_id": state !== null ? state.item.product_id : null,
                "category_id": info.category,
                "product_code": info.product_code,
                "product_name": info.product_name,
                "description": info.description,
                "satuan": info.satuan,
                "rasio_satuan": info.rasio_satuan,
                "isActive": isActive,
                "outlet": [],
            },
        }

        if (variantProductDel.length > 0) {
            data.variant_product_delete = variantProductDel;
        }

        if (imageDel !== undefined && imageDel.length > 0) {
            var val_img = [];
            for (let i = 0; i < imageDel.length; i++) {
                if (imageDel[i] !== null) {
                    val_img = [...val_img, imageDel[i]];
                }
            }
            if (val_img !== null) {
                data.image_delete = val_img;
            }
        }

        let row_variant = [];
        for (let i = 0; i < productVariant.length; i++) {
            var item = productVariant[i];
            var variant = {
                "variant_product": {
                    "status": item.status !== undefined ? item.status : 'edit',
                    "variant_product_id": item.id,
                    "barcode_code": item.barcode_code,
                    "variant_name": item.variant_name,
                    "price": item.price,
                    "stock": item.stock,
                    "min_order": item.min_order,
                    "SKU": item.SKU,
                    "isActive": item.isActive,
                    "discount": null
                },
                "outlet": []
            };
            if (item.discount_percent !== undefined) {
                variant.variant_product.discount = {
                    "discount_percent": item.discount_percent,
                    "discount_percent_2": item.discount_percent_2,
                    "discount_price": item.discount_price,
                    "discount_start": item.discount_start,
                    "discount_end": item.discount_end,
                };
                if (item.discount_id !== undefined) {
                    variant.variant_product.discount.discount_id = item.discount_id;
                }
            }
            row_variant.push(variant)
        }
        
        var row_bundle = [];
        for (let i = 0; i < bundle.length; i++) {
            row_bundle.push(bundle[i].product_id);
        }
        data.variant = row_variant;
        data.bundle = row_bundle;
        if (state !== null) {
            postApi('PUT', '/data_product', data, 'json');
        } else {
            postApi('POST', '/data_product', data, 'json');
        }
    }

    const saveVariant = (ev) => {
        var times = new Date().getTime();
        var discount_price;
        var price_after_discount;
        var discount_start;
        var discount_end;
        var discount_percent;
        if (ev.discount_date) {
            discount_percent = ev.discount;
            discount_price = Number(ev.discount) / 100 * Number(ev.price);
            price_after_discount = Number(ev.price) - discount_price;
            discount_start = ev.discount_date_start.format(dateFormat);
            discount_end = ev.discount_date_end.format(dateFormat);
        }
        var row = {
            barcode_code: ev.barcode,
            variant_name: ev.variant_name,
            price: ev.price,
            min_order: 1,
            stock: ev.stock,
            satuan: ev.satuan,
            discount_percent: discount_percent,
            discount_percent_2: 0,
            discount_price: discount_price,
            price_after_discount: price_after_discount,
            discount_start: discount_start,
            discount_end: discount_end,
            SKU: ev.SKU,
            isActive: isActiveVariant,
            image: imageUrl
        }
        if (dataModal !== null) {
            row.value = dataModal.id;
            row.title = ev.variant_name;
            if (dataModal.imageNoUrl !== undefined) {
                setImageDel([...imageDel, dataModal.imageNoUrl]);
            }
            var res = productVariant.map(obj =>
                obj.id === dataModal.id ?
                    {
                        ...obj,
                        ...row
                    }
                    : obj);
            setProductVariant(res);
            setDataProductVariant(res);
            setdataModal(null);
        } else {
            row.id = times;
            row.value = times;
            row.title = ev.variant_name;
            row.status = 'add';
            productVariant.push(row);
            setProductVariant(productVariant);
            setDataProductVariant(productVariant);
        }
        setImageUrl(null);
        formVariant.resetFields();
        setIsModalVariant(false);
    }

    const sendImage = (res) => {
        if (file.length > 0) {
            if (res.variant_product_id.length > 0) {
                const forms = new FormData();
                for (let i = 0; i < res.variant_product_id.length; i++) {
                    if (file[i] !== undefined && file[i] !== null) {
                        forms.append("variant_product_id", res.variant_product_id[i]);
                        forms.append("image", file[i]);
                        postApi('POST', '/productimage', forms, null, 'form');
                    }
                }
            }
        }
        navigate(-1)
    }

    const postApi = (method, url, values, header) => {
        const dataReq = {
            method: method,
            url: url,
            data: {
                data: values,
                headers: {
                    Authorization: 'Bearer ' + token,
                    "Content-Type": header === 'json' ? 'application/json' : 'multipart/form-data',
                }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === 200) {
                header === 'json' && sendImage(res.data)
            } else {
                modalError(res.message);
            }
        }).catch((e) => {
            console.log('masuk')
            console.log(e);
        })
    }

    const searchData = (value) => {
        var arr = [];
        if (value === null || value === '') {
            setProductVariant(dataProductVariant);
        } else {
            dataProductVariant.find(item => {
                const op = new RegExp(".*" + value + ".*", 'ig');
                const hsl = item.variant_name.match(op);
                if (hsl !== null) {
                    arr.push(item)
                }
                return '';
            })
            setProductVariant(arr);
        }
    }

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div
                style={{
                    marginTop: 8,
                }}
            >
                Upload
            </div>
        </div>
    );

    const closeModal = () => {
        if (uploadCount > 0) {
            file.splice((file.length - 1), 1);
            setUploadCount(0);
        }
        setdataModal(null);
        setIsModalVariant(false);
        setModalBundle(false);
    }

    const saveBundle = (ev) => {
        var row = JSON.parse(ev.product_id);
        setBundle([...bundle,{
            product_id:row.product_id,
            product_code: row.product_code,
            product_name: row.product_name,
            min_order: row.min_order
        }]);
        formBundle.resetFields();
        setModalBundle(false);
    }

    const Information = () => {
        return (
            <div>
                <Form form={form} name="form_product" layout="vertical" >
                    <Row>
                        <Col span={16}>
                            <Form.Item
                                name="product_code"
                                label="Kode Barang"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Kode Barang kosong!'
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                name="category"
                                label="Kategori"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Kategori kosong!'
                                    },
                                ]}
                            >
                                <TreeSelect
                                    showSearch
                                    style={{
                                        width: '100%',
                                    }}
                                    dropdownStyle={{
                                        maxHeight: 400,
                                        overflow: 'auto',
                                    }}
                                    placeholder="Pilih Kategori"
                                    allowClear
                                    treeNodeFilterProp='title'
                                    treeDefaultExpandAll
                                    treeData={category}
                                />
                            </Form.Item>
                            <Form.Item
                                name="product_name"
                                label="Nama Barang"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Nama Barang kosong!'
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                name="description"
                                label="Deskripsi"
                                rules={[
                                    {
                                        required: false,
                                        message: 'Deskripsi kosong!'
                                    },
                                ]}
                            >
                                <Input.TextArea />
                            </Form.Item>
                            <Form.Item
                                name="satuan"
                                label="Nama Satuan"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Nama Satuan kosong!'
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                name="rasio_satuan"
                                label="Rasio Satuan"
                                rules={[
                                    {
                                        required: false,
                                        message: 'Rasio Satuan kosong!'
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                name="isActive"
                                label="Status"
                                rules={[
                                    {
                                        required: false,
                                        message: 'Status kosong!'
                                    },
                                ]}
                            >
                                <Switch
                                    checkedChildren="Aktif"
                                    unCheckedChildren="Tidak Aktif"
                                    defaultChecked
                                    checked={isActive}
                                    onChange={() => setIsActive(!isActive)}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{ textAlign: 'center' }} >
                            {/* <p>Upload Gambar</p>
                            <Upload
                                listType="picture-card"
                                showUploadList={false}
                                onChange={uploadImage}
                                beforeUpload={() => false}
                            >
                                {imageUrl ? (
                                    <img
                                        src={imageUrl}
                                        alt="avatar"
                                        style={{ height: 140, width: 140 }}
                                    />
                                ) : (
                                    uploadButton
                                )}
                            </Upload> */}
                        </Col>
                    </Row>
                </Form>
            </div>
        )
    }

    const renderProduct = () => {
        return (
            <>
                <Row>
                    <Col span={12}>
                        <Button style={{ marginBottom: 10, marginRight: 10 }} type="primary" onClick={() => openForm(null, 'add')}>
                            <PlusOutlined />
                            <b style={{ marginLeft: 5 }}>Tambah Varian Produk</b>
                        </Button>
                    </Col>
                    <Col span={12} style={{ display: 'flex', justifyContent: 'flex-end' }} >
                        <Search
                            style={{ width: 350 }}
                            placeholder="Pencarian"
                            allowClear
                            enterButton="Search"
                            size="medium"
                            onSearch={searchData}
                        />
                    </Col>
                </Row>
                <Table
                    size="middle"
                    columns={columns}
                    dataSource={[...productVariant]}
                />
                <Modal title="Form Varian" width={800} open={isModalVariant} onOk={formVariant.submit} onCancel={() => closeModal()} okText="Simpan" >
                    <Form form={formVariant} name="form_variant" layout="vertical" onFinish={saveVariant}>
                        <Row>
                            <Col span={8}>
                                Upload Gambar
                                <Upload
                                    listType="picture-card"
                                    showUploadList={false}
                                    onChange={uploadImage}
                                    beforeUpload={() => false}
                                >
                                    {imageUrl ? (
                                        <img
                                            src={imageUrl}
                                            alt="avatar"
                                            style={{ height: 140, width: 140 }}
                                        />
                                    ) : (
                                        uploadButton
                                    )}
                                </Upload>
                            </Col>
                            <Col span={16}>
                                <Form.Item
                                    style={{ marginBottom: 10 }}
                                    name="barcode"
                                    label="Barcode"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Barcode kosong!'
                                        },
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                                <Form.Item
                                    style={{ marginBottom: 10 }}
                                    name="variant_name"
                                    label="Nama Varian"
                                    rules={[
                                        {
                                            required: false,
                                            message: 'Nama Variant kosong!'
                                        },
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                                <Form.Item
                                    style={{ marginBottom: 10 }}
                                    name="isActive"
                                    label="Status"
                                    rules={[
                                        {
                                            required: false,
                                            message: 'Status kosong!'
                                        },
                                    ]}
                                >
                                    <Switch
                                        checkedChildren="Aktif"
                                        unCheckedChildren="Tidak Aktif"
                                        defaultChecked
                                        checked={isActiveVariant}
                                        onChange={() => setIsActiveVariant(!isActiveVariant)}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        {
                            formVariant.getFieldValue('discount') != null ?
                                <Card size="small" style={{ marginTop: 20, marginBottom: 10 }} >
                                    <Row>
                                        <Col span={8}>
                                            Harga setelah diskon
                                        </Col>
                                        <Col span={16} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <b>{currencyFormat(priceAfterVariantDiscount)}</b>
                                        </Col>
                                    </Row>
                                </Card>
                                :
                                null
                        }
                        <Row>
                            <Col span={11}>
                                <Form.Item
                                    name="price"
                                    label="Harga"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Harga kosong!'
                                        },
                                    ]}
                                >
                                    <InputNumber
                                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                                        style={{ width: '100%' }}
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="stock"
                                    label="Stok"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Stok kosong!'
                                        },
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                                <Form.Item
                                    name="satuan"
                                    label="Satuan"
                                    rules={[
                                        {
                                            required: false,
                                            message: 'Satuan kosong!'
                                        },
                                    ]}
                                >
                                    <Input disabled={true} />
                                </Form.Item>
                            </Col>
                            <Col span={2} />
                            <Col span={11}>
                                <Form.Item
                                    name="discount"
                                    label="Diskon (%)"
                                    rules={[
                                        {
                                            required: false,
                                            message: 'Diskon kosong!'
                                        },
                                    ]}
                                >
                                    <InputNumber
                                        style={{
                                            width: '100%',
                                        }}
                                        min={0}
                                        max={100}
                                        formatter={(value) => `${value}`}
                                        onChange={(v) => {
                                            var dis = ((100 - Number(v)) / 100);
                                            var price = formVariant.getFieldValue('price');
                                            var afterDis = dis * Number(price);
                                            setPriceAfterVariantDiscount(afterDis);
                                        }}
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="discount_date_start"
                                    label="Tanggal Diskon Mulai"
                                    rules={[
                                        {
                                            required: false,
                                            message: 'Tanggal Diskon Mulai kosong!'
                                        },
                                    ]}
                                >
                                    <DatePicker style={{ width: '100%' }} format={'DD-MM-YYYY'} />
                                </Form.Item>
                                <Form.Item
                                    name="discount_date_end"
                                    label="Tanggal Diskon Berakhir"
                                    rules={[
                                        {
                                            required: false,
                                            message: 'Tanggal Diskon Berakhir kosong!'
                                        },
                                    ]}
                                >
                                    <DatePicker style={{ width: '100%' }} format={'DD-MM-YYYY'} />
                                </Form.Item>
                                <Form.Item
                                    name="SKU"
                                    label="SKU"
                                    rules={[
                                        {
                                            required: false,
                                            message: 'SKU kosong!'
                                        },
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
            </>
        );
    }

    const renderCategoryDiscount = () => {
        return (
            <>
                <Row>
                    <Col span={12}>
                        {/* <Button style={{ marginBottom: 10, marginRight: 10 }} type="primary" onClick={() => openForm(null, 'add')}>
                            <PlusOutlined />
                            <b style={{ marginLeft: 5 }}>Tambah Kategori Harga</b>
                        </Button> */}
                    </Col>
                    <Col span={12} style={{ display: 'flex', justifyContent: 'flex-end' }} >
                        <Search
                            style={{ width: 350 }}
                            placeholder="Pencarian"
                            allowClear
                            enterButton="Search"
                            size="medium"
                            onSearch={searchData}
                        />
                    </Col>
                </Row>
                <Table
                    size="middle"
                    columns={column_category_price}
                    dataSource={[...productCategoryPrice]}
                />
            </>
        );
    }

    const renderBundle = () => {
        return (
            <>
                <Row>
                    <Col span={12}>
                        <Button style={{ marginBottom: 10, marginRight: 10 }} type="primary" onClick={() => setModalBundle(true)}>
                            <PlusOutlined />
                            <b style={{ marginLeft: 5 }}>Tambah Bundle</b>
                        </Button>
                    </Col>
                    <Col span={12} style={{ display: 'flex', justifyContent: 'flex-end' }} >
                        {/* <Search
                            style={{ width: 350 }}
                            placeholder="Pencarian"
                            allowClear
                            enterButton="Search"
                            size="medium"
                            onSearch={searchData}
                        /> */}
                    </Col>
                </Row>
                <Table
                    size="middle"
                    columns={column_bundle}
                    dataSource={[...bundle]}
                />
                <Modal title="Form Bundle" width={800} open={isModalBundle} onOk={formBundle.submit} onCancel={() => closeModal()} okText="Simpan" >
                    <Form form={formBundle} name="form_bundle" layout="vertical" onFinish={saveBundle}>
                        <Form.Item
                            style={{ marginBottom: 10 }}
                            name="product_id"
                            label="Nama Produk"
                            rules={[
                                {
                                    required: true,
                                    message: 'Nama Produk kosong!'
                                },
                            ]}
                        >
                            <TreeSelect
                                showSearch
                                style={{
                                    width: '100%',
                                }}
                                dropdownStyle={{
                                    maxHeight: 400,
                                    overflow: 'auto',
                                }}
                                placeholder="Pilih Produk"
                                allowClear
                                treeNodeFilterProp='title'
                                treeDefaultExpandAll
                                treeData={product}
                            />
                        </Form.Item>
                    </Form>
                </Modal>
            </>
        );
    }
    const items = [
        {
            key: 'information',
            label: 'Informasi',
            children: Information(),
        },
        {
            key: 'product',
            label: 'Barang',
            children: renderProduct(),
        },
        // {
        //     key: 'category_price',
        //     label: 'Kategori Harga',
        //     children: renderCategoryDiscount(),
        // },
        // {
        //     key: 'bundle_product',
        //     label: 'Produk Bundle',
        //     children: renderBundle(),
        // },
    ];

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button type="primary" onClick={save} >
                    <b style={{ marginLeft: 5 }}>Simpan</b>
                </Button>
            </div>
            <Tabs
                defaultActiveKey="1"
                items={items}
            />
        </div>
    );
}

export default FormProduct;